import revsCommon from './revsCommon'

export default {
  ...revsCommon,
  problem: item => item?.relate?.problem ?? '',
  solution: item => item?.expand?.solution ?? '',
}
